import { Select, type SelectProps } from "@mantine/core"
import { useState } from "react"

export function useSelectCreatable(data: string[]) {
  const [search, setSearch] = useState("")
  const exactOptionMatch = data.some((option) => option === search)
  if (search.trim().length > 0 && !exactOptionMatch) {
    data = [search, ...data]
  }
  return { data, search, setSearch }
}

export function SelectCreatable({ data, ...props }: SelectProps) {
  const { data: selectData, search, setSearch } = useSelectCreatable(data as string[])
  return <Select data={selectData} searchable searchValue={search} onSearchChange={setSearch} {...props} />
}
